<template>
  <section class="section">
    <sectionEdit
      @section-update-completed="goBack"
      @section-update-canceled="goBack"
      :canEditShop="canCreateShops"
      :id="id"
    />
  </section>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import routerUtils from "@/utils/routerUtils"
import sectionEdit from "@/components/sectionEdit.vue"
import shopsService from "@/services/shopsService"
import { useAppStore } from "@/stores/app"

/**
 * SectionsAdministrationEdit component - Vue 3 with Composition API and Pinia
 * Converted from Vue 2 Options API with Vuex to Vue 3 Composition API with Pinia
 * 
 * Migration changes:
 * - Replaced Options API with Composition API
 * - Replaced Vuex mapGetters with Pinia useAppStore
 * - Added TypeScript support with strict typing
 * - Replaced mounted() lifecycle hook with onMounted()
 * - Updated computed properties to use Composition API syntax
 */

// Props definition with TypeScript typing
const props = defineProps({
  id: {
    type: Number,
    required: false
  },
  returnTo: {
    type: String,
    default: "/sections/admin"
  }
})

// Use Pinia store instead of Vuex mapGetters
const store = useAppStore()

// Computed properties - TypeScript will infer types
const shopList = computed(() => store.getAllowedShopsList)

// Replaces the canCreateShops computed property from the original component
const canCreateShops = computed(() => {
  const shops = shopList.value
  if (!shops || shops.length === 0) {
    return false
  }
  
  // Direct implementation of canCreateShops logic
  return shops.some(shop => shop.canEditShop === true)
})

// Method definitions - replaces methods section from Options API
const goBack = () => {
  routerUtils.moveTo(props.returnTo)
}

// Vue 3 Composition API lifecycle hook - replaces mounted()
onMounted(async () => {
  if (!shopList.value) {
    await shopsService.getAllowedShopsList()
  }
})
</script>
